import { useNavigate } from "react-router-dom";
import SectionHeader from "@/components/base/SectionHeader";
import CapabilityCard from "@/components/base/CapabilityCard";

const coreCapabilities = [
  {
    title: "Enterprise Infrastructure & Network Engineering",
    description: "LAN/WAN engineering, server and collaboration support, VMware and vCenter deployment, virtualization, infrastructure modernization, and platform migration.",
    icon: "ri-server-line",
    href: "/capabilities/infrastructure-network-engineering",
    tags: ["LAN/WAN", "VMware", "Virtualization"],
    featured: true,
  },
  {
    title: "Database & Data Platform Services",
    description: "Database engineering, administration, and platform support for Oracle, SQL Server, and relational database environments. Schema management and data integrity.",
    icon: "ri-folder-3-line",
    href: "/capabilities/database-data-platform",
    tags: ["Oracle", "SQL Server", "DBA"],
    featured: true,
  },
  {
    title: "Application & Platform Engineering",
    description: "Enterprise application support, platform engineering, WebSphere support, application maintenance, data development, and integration support.",
    icon: "ri-layout-grid-line",
    href: "/capabilities/application-platform-engineering",
    tags: ["WebSphere", "Integration", "Python"],
    featured: true,
  },
  {
    title: "Cloud Services",
    description: "Cloud engineering and migration built on Microsoft Azure, spanning IaaS, PaaS, hybrid cloud, storage, security, and cloud-native DevOps.",
    icon: "ri-cloud-line",
    href: "/capabilities/cloud-services",
    tags: ["Microsoft Azure", "Cloud Migration", "DevOps"],
    featured: true,
  },
];

const supportingCapabilities = [
  {
    title: "Microsoft Power Platform & SharePoint",
    description: "Power Apps, Power Automate, Power BI, SharePoint workflows, and user enablement for enterprise business applications.",
    icon: "ri-window-line",
    href: "/capabilities/microsoft-solutions",
  },
  {
    title: "Web & Digital Solutions",
    description: "Website development, CMS solutions, web portals, content migration, and accessibility-aware development for modern digital environments.",
    icon: "ri-global-line",
    href: "/capabilities/web-digital-solutions",
  },
  {
    title: "Mobile Application Development",
    description: "Custom mobile application development, cross-platform solutions, API integration, and accessibility-aware mobile UX for enterprise and government programs.",
    icon: "ri-smartphone-line",
    href: "/capabilities/mobile-application-development",
  },
  {
    title: "AI & Intelligent Engineering",
    description: "AI-assisted application engineering, data pipelines, business intelligence, workflow automation, and machine learning integration.",
    icon: "ri-ai-generate",
    href: "/capabilities/ai-intelligent-engineering",
  },
];

export default function CapabilitiesSection() {
  return (
    <section className="section-padding bg-white">
      <div className="container-page">
        <SectionHeader
          title="Core Capabilities"
          subtitle="What We Deliver"
          description="Mitaja Corporation delivers proven enterprise technology and engineering services through prime-contractor and teaming relationships."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {coreCapabilities.map((cap) => (
            <CapabilityCard key={cap.title} {...cap} />
          ))}
        </div>

        <div className="border-t border-background-200/80 pt-10">
          <SectionHeader
            title="Supporting Capabilities"
            description="Additional technology services that complement our core practice areas."
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {supportingCapabilities.map((cap) => (
              <CapabilityCard key={cap.title} {...cap} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}